
export { FullstoryScript } from "/home/runner/work/apollo/apollo/packages/shells/shared/src/presentation/atoms/fullstory-script/fullstory-script.tsx"